import { StaticImageData } from 'next/image';

import noImageSrc from '@/images/apps/common/no_img.svg';

import useCurrentLang from './useCurrentLang';

type Props = {
  pcImgSrc: string | StaticImageData;
  mobileImgSrc: string | StaticImageData;
  pcEnImgSrc: string | StaticImageData;
  mobileEnImgSrc: string | StaticImageData;
  isDesktop: boolean;
};

function useSelectImage({
  pcImgSrc,
  mobileImgSrc,
  pcEnImgSrc,
  mobileEnImgSrc,
  isDesktop,
}: Props): string | StaticImageData {
  const currentLang = useCurrentLang();

  if (currentLang === 'ko') {
    return isDesktop ? pcImgSrc : mobileImgSrc;
  }

  if (currentLang === 'en') {
    return isDesktop ? pcEnImgSrc : mobileEnImgSrc;
  }

  return noImageSrc;
}

export default useSelectImage;
